module.exports = __webpack_public_path__ + "static/Logo_Xplore_Main_negativ-940fb9d4c5ee1c775727eba48f615680.png";